import { AUTH_SUCCESS, AUTH_LOGOUT } from '../actions/constants/auth.constants';

const initialState = {
  token: null,
  user: null,
  permisos: null,
  configuracion: null,
};

export default function authReducer(state = initialState, { type, payload }) {
  switch (type) {
    case AUTH_SUCCESS: {
      const {
        token, user, permisos, configuracion,
      } = payload;
      return {
        ...state, token, user, permisos, configuracion,
      };
    }
    case AUTH_LOGOUT: {
      localStorage.clear();
      return initialState;
    }
    default:
      return state;
  }
}
